import React from 'react'
import { ImageAnswerModel } from '../../../../model/knowledge.model'
import './ImageAnswer.css'
import ReuploadButton from './ReuploadButton'
interface ImageAnswerProps {
    answer: string
    isLocked?: boolean
    onReupload?: (answer: string) => void
}
const ImageAnswer = (props: ImageAnswerProps) => {
    let answer: ImageAnswerModel = { ResourceUrl: '' }
    try {
        answer = JSON.parse(props.answer)
    } catch (error) {
        console.error(error)
    }
    return (
        <div className='answer-image-item'>
            <div
                className='answer-image'
                style={{
                    background: `url(${answer.ResourceUrl}) no-repeat center`,
                }}
            />
            {!props.isLocked && (
                <ReuploadButton
                    onResolve={(src, name) => {
                        const imageAnswer: ImageAnswerModel = {
                            ResourceUrl: src,
                            Thumb: '',
                            FileName: name,
                            SourceUrl: src,
                        }
                        props.onReupload &&
                            props.onReupload(JSON.stringify(imageAnswer))
                    }}
                />
            )}
        </div>
    )
}

export default ImageAnswer
